export const
    handSanitizer = require('./handSanitizer.svg'),
    handSoap = require('./handSoap.svg'),
    handWipes = require('./handWipes.svg'),
    tissues = require('./tissues.svg'),
    trashbag = require('./trashbag.svg'),
    trashBin = require('./trashBin.svg')